<div class="container-fluid p-3">
  <mat-card>
    <mat-card-header class="pb-0">
      <mat-card-title>Carga Masiva de Novedades Comerciales</mat-card-title>
    </mat-card-header>
    <mat-card-content class="pt-3">
      <div class="row">
        <div class="col-12 col-md-12">
          <input type="file" #fileInput style="display: none" (change)="onFileSelected($event)" accept=".xlsx,.xls,.csv">
          <div class="d-flex gap-2 flex-column flex-md-row">
            <button mat-flat-button color="primary" (click)="fileInput.click()">
              <mat-icon>upload_file</mat-icon>
              Seleccionar Archivo
            </button>
            <button mat-flat-button color="warn" [disabled]="!selectedFile" (click)="procesarArchivo()">
              <mat-icon>check_circle</mat-icon>
              Procesar Archivo
            </button>
            <button mat-flat-button color="basic" [disabled]="!selectedFile" (click)="cancelarSeleccionArchivo()">
              <mat-icon>close</mat-icon>
              Cancelar
            </button>
            <span class="ms-2 align-self-center" *ngIf="selectedFile">
              {{selectedFile.name}}
            </span>
          </div>
          <div class="mt-2">
            <small class="text-muted">
              El archivo Excel debe contener las columnas: periodo, c_vend, c_tiponovedad, dias, observaciones
            </small>
          </div>
        </div>
      </div>
    </mat-card-content>
  </mat-card>

  <!-- Panel de Instrucciones y Plantilla -->
  <mat-expansion-panel class="mb-3 mt-3">
    <mat-expansion-panel-header>
      <mat-panel-title>
        <mat-icon class="mr-2">help_outline</mat-icon>
        Instrucciones de Carga
      </mat-panel-title>
    </mat-expansion-panel-header>

    <div class="instructions-container">
      <!-- Descripción -->
      <div class="mb-3">
        <h3 class="text-lg font-semibold mb-2">Formato del Archivo</h3>
        <p class="text-gray-600 mb-4">
          Para cargar las novedades comerciales, utilice la plantilla Excel proporcionada.
          Asegúrese de seguir el formato especificado para cada campo.
        </p>
      </div>

      <!-- Tabla de Campos -->
      <div class="mb-4">
        <table mat-table [dataSource]="camposRequeridos" class="w-full">
          <ng-container matColumnDef="campo">
            <th mat-header-cell *matHeaderCellDef>Campo</th>
            <td mat-cell *matCellDef="let elemento">{{elemento.campo}}</td>
          </ng-container>

          <ng-container matColumnDef="formato">
            <th mat-header-cell *matHeaderCellDef>Formato</th>
            <td mat-cell *matCellDef="let elemento">{{elemento.formato}}</td>
          </ng-container>

          <ng-container matColumnDef="ejemplo">
            <th mat-header-cell *matHeaderCellDef>Ejemplo</th>
            <td mat-cell *matCellDef="let elemento">{{elemento.ejemplo}}</td>
          </ng-container>

          <ng-container matColumnDef="descripcion">
            <th mat-header-cell *matHeaderCellDef>Descripción</th>
            <td mat-cell *matCellDef="let elemento">{{elemento.descripcion}}</td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="columnasTabla"></tr>
          <tr mat-row *matRowDef="let row; columns: columnasTabla;"></tr>
        </table>
      </div>

      <!-- Notas Importantes -->
      <div class="mb-4">
        <h4 class="text-md font-semibold mb-2">Notas Importantes:</h4>
        <ul class="list-disc pl-5 text-gray-600">
          <li>No modificar el orden de las columnas</li>
          <li>No dejar campos vacíos</li>
          <li>El periodo debe ser una fecha válida en formato YYYYMM</li>
          <li>El código de vendedor debe existir en el sistema</li>
          <li>El tipo de novedad debe ser un código válido</li>
        </ul>
      </div>

      <!-- Botón de Descarga -->
      <div class="flex justify-start">
        <a mat-raised-button color="primary" href="/assets/templates/novedadescomerciales/plantilla_novedades.xlsx"
          download="plantilla_novedades_comerciales.xlsx" class="flex items-center">
          <mat-icon class="mr-2">download</mat-icon>
          Descargar Plantilla Excel
        </a>
      </div>
    </div>
  </mat-expansion-panel>

  <!-- Formulario de Novedades -->
  <mat-card class="mt-3">
    <mat-card-header class="pb-0">
      <mat-card-title>{{ isEditing ? 'Editar' : 'Crear' }} Novedad Comercial</mat-card-title>
    </mat-card-header>
    <mat-card-content class="pt-3">
      <form [formGroup]="novedadForm" (ngSubmit)="onSubmit()">
        <!-- Primera fila con 4 campos -->
        <div class="row g-3 align-items-center">
          <!-- Periodo -->
          <div class="col-md-2 col-sm-12">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Periodo</mat-label>
              <mat-select formControlName="periodo" required>
                <mat-option *ngFor="let periodo of periodosAbiertos" [value]="periodo">
                  {{periodo.periodo}}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="novedadForm.get('periodo')?.hasError('required')">
                El periodo es requerido
              </mat-error>
            </mat-form-field>
          </div>

          <!-- Tipo de Novedad -->
          <div class="col-md-3 col-sm-12">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Tipo de Novedad</mat-label>
              <mat-select formControlName="c_tiponovedad" required>
                <mat-option *ngFor="let tipo of tiposNovedad" [value]="tipo.codigo">
                  {{tipo.descripcion}}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="novedadForm.get('c_tiponovedad')?.hasError('required')">
                El tipo de novedad es requerido
              </mat-error>
            </mat-form-field>
          </div>

          <!-- Vendedor -->
          <div class="col-md-5 col-sm-12">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Vendedor</mat-label>
              <input type="text" matInput [formControl]="vendedorControl" [matAutocomplete]="auto"
                [readonly]="isEditing"
                [matTooltip]="isEditing ? 'No se puede modificar el vendedor en modo edición' : ''"
                [matTooltipPosition]="'above'">
              <button mat-icon-button matSuffix (click)="mostrarListaVendedores()" type="button" [disabled]="isEditing"
                [matTooltip]="isEditing ? 'No se puede modificar el vendedor en modo edición' : ''">
                <mat-icon>search</mat-icon>
              </button>
              <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayVendedor">
                <mat-option *ngFor="let vendedor of vendedoresFiltrados | async" [value]="vendedor">
                  {{vendedor.codigo_vendedor}} - {{vendedor.nombre_vendedor}}
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>
          </div>

          <!-- Días -->
          <div class="col-md-2 col-sm-12">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Días</mat-label>
              <input matInput type="number" formControlName="dias" required min="0">
              <mat-error *ngIf="novedadForm.get('dias')?.hasError('required')">
                Los días son requeridos
              </mat-error>
              <mat-error *ngIf="novedadForm.get('dias')?.hasError('min')">
                Los días deben ser mayor o igual a 0
              </mat-error>
            </mat-form-field>
          </div>
        </div>

        <!-- Segunda fila con Observaciones -->
        <div class="row mt-3">
          <div class="col-12">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Observaciones</mat-label>
              <textarea matInput formControlName="observaciones" style="text-transform: uppercase;" rows="2"
                maxlength="500"></textarea>
              <mat-hint align="end">{{novedadForm.get('observaciones')?.value?.length || 0}}/500</mat-hint>
              <mat-error *ngIf="novedadForm.get('observaciones')?.hasError('maxlength')">
                Las observaciones no pueden exceder los 500 caracteres
              </mat-error>
            </mat-form-field>
          </div>
        </div>

        <!-- Botones del formulario -->
        <div class="d-flex gap-2 mt-3 justify-content-end">
          <button mat-flat-button color="primary" type="submit"
            [disabled]="!novedadForm.valid || !vendedorControl.value || isLoading" class="btn btn-primary">
            <mat-spinner diameter="20" *ngIf="isLoading"></mat-spinner>
            <span *ngIf="!isLoading">{{ isEditing ? 'Actualizar' : 'Guardar' }}</span>
          </button>
          <button mat-flat-button type="button" (click)="resetForm()" *ngIf="isEditing" class="btn btn-secondary">
            Cancelar
          </button>
        </div>
      </form>
    </mat-card-content>
  </mat-card>

  <mat-card class="mt-3">
    <mat-card-header class="pb-0">
      <mat-card-title>Lista de novedades comerciales</mat-card-title>
    </mat-card-header>

    <mat-card-content>
      <div class="row mt-3">
        <div class="col-12 col-md-6">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Buscar</mat-label>
            <input matInput (keyup)="applyFilter($event)" placeholder="Buscar novedad..." #input>
          </mat-form-field>
        </div>
      </div>

      <div class="table-responsive">
        <table mat-table [dataSource]="dataSource" class="table w-100">
          <!-- Periodo Column -->
          <ng-container matColumnDef="periodo">
            <th mat-header-cell *matHeaderCellDef style="width: 15%; font-size: 11px;">Periodo</th>
            <td mat-cell *matCellDef="let element" style="vertical-align: middle; font-size: 11px;">
              {{element.periodo}}
              <mat-icon *ngIf="!isPeriodoAbierto(element.periodo)" 
                       matTooltip="Periodo cerrado"
                       class="text-warning" 
                       style="font-size: 16px; height: 16px; width: 16px; margin-left: 4px; vertical-align: middle;">
                lock
              </mat-icon>
            </td>
          </ng-container>

          <!-- Tipo Novedad Column -->
          <ng-container matColumnDef="c_tiponovedad">
            <th mat-header-cell *matHeaderCellDef style="width: 25%;font-size: 11px;">Tipo Novedad</th>
            <td mat-cell *matCellDef="let element" style="vertical-align: middle; font-size: 11px;">
              {{getTipoNovedadDescripcion(element.c_tiponovedad)}}</td>
          </ng-container>

          <!-- Vendedor Column -->
          <ng-container matColumnDef="c_ven">
            <th mat-header-cell *matHeaderCellDef style="width: 40%;font-size: 11px;">Vendedor</th>
            <td mat-cell *matCellDef="let element" style="vertical-align: middle; font-size: 11px;">{{getVendedorNombre(element.c_ven)}}</td>
          </ng-container>

          <!-- Días Column -->
          <ng-container matColumnDef="dias">
            <th mat-header-cell *matHeaderCellDef style="width: 15%;font-size: 11px;">Días</th>
            <td mat-cell *matCellDef="let element" style="vertical-align: middle; font-size: 11px;">{{element.dias}}</td>
          </ng-container>

          <!-- Acciones Column -->
          <ng-container matColumnDef="acciones">
            <th mat-header-cell *matHeaderCellDef style="width: 15%; text-align: center; font-size: 11px;">Acciones</th>
            <td mat-cell *matCellDef="let element" style="vertical-align: middle;">
              <div style="display: flex; justify-content: center; gap: 4px;">
                <button mat-icon-button 
                        [disabled]="!isPeriodoAbierto(element.periodo)"
                        (click)="onEdit(element)"
                        [matTooltip]="isPeriodoAbierto(element.periodo) ? 'Editar' : 'No se puede editar un registro de un periodo cerrado'">
                  <mat-icon [ngClass]="{'text-dark': isPeriodoAbierto(element.periodo)}">edit</mat-icon>
                </button>
                <button mat-icon-button 
                        [disabled]="!isPeriodoAbierto(element.periodo)"
                        (click)="onDelete(element.id)"
                        [matTooltip]="isPeriodoAbierto(element.periodo) ? 'Eliminar' : 'No se puede eliminar un registro de un periodo cerrado'">
                  <mat-icon [ngClass]="{'text-dark': isPeriodoAbierto(element.periodo)}">delete</mat-icon>
                </button>
                <button mat-icon-button (click)="verDetalle(element)" matTooltip="Ver detalles">
                  <mat-icon class="text-dark">info</mat-icon>
                </button>
              </div>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

           <!-- Mensaje cuando no hay datos -->
           <tr class="mat-row" *matNoDataRow>
            <td class="mat-cell text-center" [attr.colspan]="displayedColumns.length" style="padding: 20px;">
              No se encontraron registros
            </td>
          </tr>
        </table>

        <mat-paginator [pageSizeOptions]="[5, 10, 25, 100]"
          aria-label="Seleccionar página de novedades"></mat-paginator>
      </div>
    </mat-card-content>
  </mat-card>
</div>